import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LiveNowSection from "@/pages/home/components/LiveNowSection";
import CollectionsSection from "@/pages/home/components/CollectionsSection";
import BrandIntro from "@/pages/home/components/BrandIntro";

export default function Home() {
  usePageMeta(
    "jrs直播 - 专业体育赛事直播平台，精彩赛事实时观看",
    "jrs直播为用户提供丰富的体育赛事直播内容，覆盖篮球、足球、电竞等热门项目，支持多赛事同时观看，助您不错过任何精彩瞬间。",
    "jrs直播,体育直播,赛事直播,篮球直播,足球直播,电竞直播,实时体育赛事",
  );

  return (
    <>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LiveNowSection />
      <CollectionsSection />
      <BrandIntro />
    </>
  );
}